import React from 'react';
import { AccordionLevelType, PaddingProps } from '@drone-js/core';

export enum ContentEnum {
    // ----- contentsHandler component
    VerticalContentHandler = 'VerticalContentHandler',
    TabsContentHandler = 'TabsContentHandler',
    // ----- content components
    Breadcrumb = 'Breadcrumb',
    TitleSection = 'TitleSection',
    MosaicGallery = 'MosaicGallery',
    PackageOptions = 'PackageOptions',
    AtAGlance = 'AtAGlance',
    ReviewSection = 'ReviewSection',
    Highlight = 'Highlight',
    ExploringActivitiesCarousel = 'ExploringActivitiesCarousel',
    AdditionalInformation = 'AdditionalInformation',
    CancellationPolicy = 'CancellationPolicy',
    IntroductionSummary = 'IntroductionSummary',
    SimCardSpec = 'SimCardSpec',
    DepartureAndReturn = 'DepartureAndReturn',
    WhatToExpect = 'WhatToExpect',
    Location = 'Location',
    SuggestedRoute = 'SuggestedRoute',
    FAQs = 'FAQs',
    AboutActivity = 'AboutActivity',
}

export enum AccordionVariant {
    None = 'None',
    Collapsed = 'Collapsed',
    Expanded = 'Expanded',
}

export enum ContainerVariant {
    None = 'None',
    Card = 'Card',
}

export enum ContainerDisplayVariant {
    Accordion = 'accordion',
    Container = 'container',
    Both = 'both',
    None = 'none',
}

export enum DividerVariant {
    None = 'none',
    Line = 'line',
}

export interface CommonDisplayProps extends React.PropsWithChildren {
    dividerVariant?: DividerVariant;
    pt?: PaddingProps['pt'];
    pb?: PaddingProps['pb'];
}

export interface ContainerDisplayProps extends CommonDisplayProps {
    display: ContainerDisplayVariant.Container;
    containerVariant?: ContainerVariant;
}

export interface AccordionDisplayProps extends CommonDisplayProps {
    display: ContainerDisplayVariant.Accordion;
    accordionVariant?: AccordionVariant;
    level?: AccordionLevelType;
}

export interface CombinedDisplayProps extends Omit<ContainerDisplayProps, 'display'>, Omit<AccordionDisplayProps, 'display'> {
    display: ContainerDisplayVariant.Both;
}

export interface EmptyDisplayProps extends CommonDisplayProps {
    display: ContainerDisplayVariant.None;
}

export type ContentWrapperConfigProps = ContainerDisplayProps | AccordionDisplayProps | CombinedDisplayProps | EmptyDisplayProps;

export interface ReviewSectionSpecificProps {
    variant: ReviewSectionVariant;
}

export interface TitleSectionSpecificProps {
    variant: TitleSectionVariant;
}

export interface MosaicGallerySpecificProps {
    variant?: MosaicGalleryVariant;
}

export enum TitleSectionVariant {
    WithThumbnail = 'WithThumbnail',
    NoThumbnail = 'NoThumbnail',
}

export enum MosaicGalleryVariant {
    Default = 'Default',
    SingleImage = 'SingleImage',
}
export enum PackageOptionsVariant {
    Default = 'Default',
    Simplified = 'Simplified',
}

export enum ReviewSectionVariant {
    Full = 'Full',
    Overview = 'Overview',
    OverviewOnMobile = 'OverviewOnMobile',
}

export enum DisplaySectionName {
    LandingPageTop = 'LandingPageTop',
    LandingPageMain = 'LandingPageMain',
    InfoOverlay = 'InfoOverlay',
}

export enum BackgroundColor {
    WHITE = 'WHITE',
    GRAY = 'GRAY',
}

export enum LandingPageTopContentPaddingVariant {
    TopAndBottom = 'TopAndBottom',
    TopOnly = 'TopOnly',
}

export enum FooterVariant {
    Default = 'Default', // Dynamic footer can switch between Booking and See Option
    BookingOnly = 'BookingOnly',
    SeeOptionOnly = 'SeeOptionOnly',
}

export interface LandingPageMainContentVariant {
    backgroundColor: BackgroundColor;
    desktopPb: PaddingProps['pb'];
    desktopPt: PaddingProps['pt'];
    mobilePb: PaddingProps['pb'];
    mobilePt: PaddingProps['pt'];
    footerVariant: FooterVariant;
}

export interface LandingPageTopContentVariant {
    desktopPb: PaddingProps['pb'];
    desktopPt: PaddingProps['pt'];
    mobilePb: PaddingProps['pb'];
    mobilePt: PaddingProps['pt'];
}
